import * as React from "react";
import moment from "moment-jalaali";
import {Button, Col, Form, Icon, Input, message, Row, Select, Switch} from "antd";
import {createRequest, fetchItemRequest, updateRequest} from "../../actions/channel";
import {Conductor, LiveStreamConductorStatus} from "../../models/conductor";
import {FormattedMessage} from "react-intl";
import withFormWrapper from "../../hocs/withFormWrapper";
import {Channel} from '../../models/channel';
import DatePicker from "react-datepicker2";
import {showDate} from "../../utils";
import channelApi from "../../api/channel";
import conductorApi from "../../api/conductor";
import VideoSelection from "../../components/video-contents/Selection";
import {VideoContent, VideoContentStatus} from "../../models/video-content";
import {SelectionMode} from "../../models";
import Tooltip from "antd/lib/tooltip";

const Option = Select.Option;

interface PropsFromState {
  loading: boolean;
  errors?: string;
  form: any;
  conductor?: Conductor;
}

interface PropsFromDispatch {
  createRequest: typeof createRequest;
  updateRequest: typeof updateRequest;
  fetchItemRequest: typeof fetchItemRequest;
}

type ConductorFormAllProps = PropsFromState & PropsFromDispatch;

type ConductorFormStateShape = {
  id: string;
  title: string;
  slug: string;
  channel: Channel | null;
  channels: Channel[] | null;
  is_active: boolean;
  start_stream_time: Date;
  end_stream_time: Date;
  rtmp_stream_url: string;
  hls_stream_url: string;
  video_content_id: string;
  video_content: VideoContent;
  status: LiveStreamConductorStatus;
  stream_slug: string;
};


class ConductorForm extends React.Component<ConductorFormAllProps,
  ConductorFormStateShape> {
  constructor(props) {
    super(props);
    const {conductor} = props;
    this.state = {
      visible: false,
      ...this.getStateFromProps(conductor)
    };
  }

  componentDidMount() {
    channelApi.getList({ params: {} }).then((response) => {
      this.setState({ channels: response.data });
    });
  }

  getStateFromProps = (conductor: Conductor | null) => {
    const obj: any = conductor || {};
    return {
      id: obj.id,
      title: obj.title,
      slug: obj.slug,
      channel: obj.channel,
      channels: [],
      is_active: obj.is_active,
      start_stream_time: obj.start_stream_time && obj.start_stream_time !== "0001-01-01T00:00:00" ? moment(showDate(obj.start_stream_time)) : null,
      end_stream_time: obj.end_stream_time && obj.end_stream_time !== "0001-01-01T00:00:00" ? moment(showDate(obj.end_stream_time)) : null,
      rtmp_stream_url: obj.rtmp_stream_url,
      hls_stream_url: obj.hls_stream_url,
      video_content_id: obj.video_content_id,
      video_content: obj.video_content,
      status: obj.status,
      stream_slug: obj.stream_slug,
    };
  };

  fetchItem = () => {
    conductorApi
      .getItem({
        params: {
          id: this.state.id
        }
      })
      .then(({data}) => {
        const obj = this.getStateFromProps(data);
        this.setState(obj);
      })
      .catch(error => console.log(error));
  };


  getValues = () => {
    let returnValues = null;
    this.props.form.setFieldsValue({
      "channel_id": this.state.channel && this.state.channel.id,
      "start_stream_time": this.state.start_stream_time ? new Date(this.state.start_stream_time).toISOString() : null,
      "end_stream_time": this.state.end_stream_time ? new Date(this.state.end_stream_time).toISOString() : null,
      "video_content_id": this.state.video_content_id,
    });
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        returnValues = {
          ...values,
        };
      }
    });

    return {
      payload: returnValues,
      id: this.props.conductor ? this.props.conductor.id : null
    };
  };


  handleChannelSearch = (query: string) => {
    channelApi.getList({ params: { query } }).then((response) => {
      this.setState({ channels: response.data });
    });
  };

  onChangeChannel = (channel: string): void => {
    const localChannel: Channel = this.state.channels?.find(elem => elem.id === channel)!;
    this.setState({
      channel: localChannel
    });
  };

  onChangeStartDate = date => {
    this.setState({
      start_stream_time: date
    });
  };

  onChangeEndDate = date => {
    this.setState({
      end_stream_time: date
    });
  };

  onSelectVideo = (video: VideoContent) => {
    console.log(video)
    this.setState({
      video_content_id: video.id,
      video_content: video
    });
  };

  handleAuto = () => {
    conductorApi.autoConductor(this.state.id).then((res) => {
      if(res) window.location.reload();
    }).catch(error => console.log(error));
  }

  handleResume = () => {
    conductorApi.resumeConductor(this.state.id).then((res) => {
      if(res) window.location.reload();
    }).catch(error => console.log(error));
  };

  handleInterrupt = () => {
    conductorApi.interruptConductor(this.state.id).then((res) => {
      if(res) window.location.reload();
    }).catch(error => console.log(error));
  };

  handleStart = () => {
    conductorApi.startConductor(this.state.id).then((res) => {
      if(res) window.location.reload();
    }).catch(error => console.log(error));
  };

  handleEnd = () => {
    conductorApi.endConductor(this.state.id).then((res) => {
      if(res) window.location.reload();
    }).catch(error => console.log(error));
  };

  handlePause = () => {
    conductorApi.pauseConductor(this.state.id).then((res) => {
      if(res) window.location.reload();
    }).catch(error => console.log(error));
  };

  handleStatusTitle = (status: LiveStreamConductorStatus) => {
    switch (status) {
      case LiveStreamConductorStatus.stream_ended_automatically:
        return "اتمام (اتوماتیک)";
      case LiveStreamConductorStatus.stream_ended_manually:
        return "اتمام (دستی)";
      case LiveStreamConductorStatus.stream_started_automatically:
        return "شروع (اتوماتیک)";
      case LiveStreamConductorStatus.stream_started_manually:
        return "شروع (دستی)";
      case LiveStreamConductorStatus.stream_paused_manually:
        return "اتمام (اتوماتیک)";
      case LiveStreamConductorStatus.waiting_for_start_stream_date:
        return "حالت اتوماتیک";
    }
  };

  handleCopySlug = () => {
    this.copyToClipboard(this.state.stream_slug);
  };

  handleCopyRtmp = () => {
    this.copyToClipboard(this.state.rtmp_stream_url);
  };

  handleCopyHls = () => {
    this.copyToClipboard(this.state.hls_stream_url);
  };

  copyToClipboard = (text: string) => {
    if (!text) {
      message.warning("به درستی کپی نشد");
      return;
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(() => {
        message.success("با موفقیت کپی شد");
      });
    } else {
      // fallback for older browsers
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "fixed";
      textarea.style.left = "-9999px";
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand("copy");
        message.success("با موفقیت کپی شد");
      } catch (err) {
        message.error("به درستی کپی نشد");
      }
      document.body.removeChild(textarea);
    }
  };

  render() {
    const {getFieldDecorator} = this.props.form;
    return (
      <Form className={'conductor-form'}>
        <Row>
          <Col span={8}>
            <Form.Item label={<FormattedMessage id="app.title" defaultMessage={`Title`}/>}>
              {getFieldDecorator("title", {
                initialValue: this.state.title,
                rules: [{
                  required: true,
                  whitespace: true,
                  message: (
                    <FormattedMessage
                      id="app.title_is_required"
                      defaultMessage={`Title is required`}
                    />
                  )
                }]
              })(<Input/>)}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label={<FormattedMessage id="app.slug" defaultMessage={`Slug`}/>}>
              {getFieldDecorator("slug", {
                initialValue: this.state.slug,
                rules: [{
                  required: true,
                  whitespace: true,
                  message: (
                    <FormattedMessage
                      id="app.slug_is_required"
                      defaultMessage={`Title is required`}
                    />
                  )
                }]
              })(<Input/>)}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label={<FormattedMessage id="app.channel" defaultMessage={`Channel`}/>}>
              {getFieldDecorator("channel_id", {
                initialValue: this.state.channel?.id,
                rules: [{
                  required: true,
                  message: (
                    <FormattedMessage
                      id={`app.channel_is_required`}
                      defaultMessage={`Channel is required!`}
                    />
                  )
                }]
              })(
                <Select
                  showSearch
                  filterOption={false}
                  onSearch={this.handleChannelSearch}
                  onChange={this.onChangeChannel}
                >
                  {this.state.channels?.map((opt, index) => (
                    <Option key={index} value={opt.id}>
                      {opt.title}
                    </Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={8}>
            <Form.Item
              label={
                <FormattedMessage
                  id="app.select_video"
                  defaultMessage={`Select Video`}
                />
              }
            >
              {getFieldDecorator("video_content_id", {
                initialValue: this.state.video_content_id,
                rules: [
                  {
                    required: true,
                    message: (
                      <FormattedMessage
                        id="app.video_is_required"
                        defaultMessage={`Select video!`}
                      />
                    )
                  }
                ]
              })(<Input type={`hidden`}/>)}
              <VideoSelection
                disabled={String(this.state.status) !== 'undefined'}
                key={this.state.video_content?.type ?? "live stream"}
                filter={{
                  is_livestream: true,
                  status: VideoContentStatus.ACTIVE
                }}
                mode={SelectionMode.DEFAULT}
                onChange={this.onSelectVideo}
                initialValue={this.state.video_content}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label={<FormattedMessage id="app.start_date" defaultMessage={`Start date`}/>}>
              {getFieldDecorator("start_stream_time", {
                initialValue: moment(this.state.start_stream_time),
                rules: [{
                  required: true,
                  message: (
                    <FormattedMessage
                      id="app.start_date_is_required"
                      defaultMessage={`Start date is required!`}
                    />
                  )
                }]
              })(<Input type={`hidden`}/>)}
              <DatePicker
                isGregorian={false}
                timePicker={true}
                value={this.state.start_stream_time}
                onChange={this.onChangeStartDate}
              />{" "}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label={<FormattedMessage id="app.end_date" defaultMessage={`End date`}/>}>
              {getFieldDecorator("end_stream_time", {
                initialValue: moment(this.state.end_stream_time),
                rules: [{
                  required: true,
                  message: (
                    <FormattedMessage
                      id="app.end_date_is_required"
                      defaultMessage={`End date is required!`}
                    />
                  )
                }]
              })(<Input type={`hidden`}/>)}
              <DatePicker
                isGregorian={false}
                timePicker={true}
                value={this.state.end_stream_time}
                onChange={this.onChangeEndDate}
              />{" "}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          {this.state.stream_slug && <Col span={24}>
            <Form.Item
              label={<FormattedMessage id="app.stream_slug" defaultMessage={`Slug Stream Link`}/>}>
              {getFieldDecorator("stream_slug", {
                initialValue: this.state.stream_slug,
                rules: [{
                  required: true,
                  whitespace: true,
                  message: (
                    <FormattedMessage
                      id="app.stream_slug_is_required"
                      defaultMessage={`Live stream slug is required`}
                    />
                  )
                }]
              })(<Input
                style={{direction: "ltr"}}
                disabled={true}
                addonBefore={
                  <Tooltip
                    title={
                      <FormattedMessage id="app.copy" defaultMessage="Copy" />
                    }
                  >
                    <Button type="link" size="small" onClick={() => this.handleCopySlug()}>
                      <Icon type="copy" />
                    </Button>
                  </Tooltip>
                }
              />)}
            </Form.Item>
          </Col>}
          {this.state.rtmp_stream_url && <Col span={24}>
            <Form.Item
              label={<FormattedMessage id="app.rtmp_live_streaming_link" defaultMessage={`RTMP Live stream link`}/>}>
              {getFieldDecorator("rtmp_stream_url", {
                initialValue: this.state.rtmp_stream_url,
                rules: [{
                  required: true,
                  whitespace: true,
                  message: (
                    <FormattedMessage
                      id="app.display_live_streaming_link_is_required"
                      defaultMessage={`Live stream link is required`}
                    />
                  )
                }]
              })(<Input
                style={{direction: "ltr"}}
                disabled={true}
                addonBefore={
                  <Tooltip
                    title={
                      <FormattedMessage id="app.copy" defaultMessage="Copy" />
                    }
                  >
                    <Button type="link" size="small" onClick={() => this.handleCopyRtmp()}>
                      <Icon type="copy" />
                    </Button>
                  </Tooltip>
                }
              />)}
            </Form.Item>
          </Col>}
          {this.state.hls_stream_url && <Col span={24}>
            <Form.Item
              label={<FormattedMessage id="app.hls_live_streaming_link" defaultMessage={`HLS Live stream link`}/>}>
              {getFieldDecorator("hls_stream_url", {
                initialValue: this.state.hls_stream_url,
                rules: [{
                  required: true,
                  whitespace: true,
                  message: (
                    <FormattedMessage
                      id="app.display_live_streaming_link_is_required"
                      defaultMessage={`Live stream link is required`}
                    />
                  )
                }]
              })(<Input
                style={{direction: "ltr"}}
                disabled={true}
                addonBefore={
                  <Tooltip
                    title={
                      <FormattedMessage id="app.copy" defaultMessage="Copy" />
                    }
                  >
                    <Button type="link" size="small" onClick={() => this.handleCopyHls()}>
                      <Icon type="copy" />
                    </Button>
                  </Tooltip>
                }
              />)}
            </Form.Item>
          </Col>}
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item label={<FormattedMessage id="app.active_conductor" defaultMessage={`Active conductor`}/>}>
              {getFieldDecorator("is_active", {
                initialValue: this.state.is_active,
              })(<Switch defaultChecked={this.state.is_active}/>)}
            </Form.Item>
          </Col>
          {String(this.state.status) !== 'undefined' && <Col span={12} style={{marginTop: '16px'}}>
            <span>
              <FormattedMessage id="app.conductor_status" defaultMessage={`Conductor status`}/>:
            </span>
            <span>{this.handleStatusTitle(this.state.status)}</span>
          </Col>}
        </Row>
        <Row style={{marginTop: '32px'}}>
          {(this.state.status === LiveStreamConductorStatus.stream_started_manually || this.state.status === LiveStreamConductorStatus.stream_paused_manually) &&
            <Button type={"primary"} onClick={() => this.handleAuto()}
                    style={{backgroundColor: 'gray', borderColor: "gray"}}>اتوماتیک</Button>}
          {(this.state.status === LiveStreamConductorStatus.waiting_for_start_stream_date) &&
            <Button type={"primary"} onClick={() => this.handleStart()} style={{marginRight: "20px"}}>شروع پخش
              زنده</Button>}
          {(this.state.status === LiveStreamConductorStatus.stream_started_automatically || this.state.status === LiveStreamConductorStatus.stream_started_manually || this.state.status === LiveStreamConductorStatus.stream_paused_manually) &&
            <Button type={"primary"} style={{backgroundColor: "red", borderColor: "red", marginRight: "20px"}}
                    onClick={() => this.handleEnd()}>اتمام پخش زنده</Button>}
          {/*{(this.state.status === LiveStreamConductorStatus.stream_started_automatically || this.state.status === LiveStreamConductorStatus.stream_started_manually) &&*/}
          {/*  <Button type={"primary"}*/}
          {/*          style={{backgroundColor: "yellow", borderColor: "yellow", marginRight: "20px", color: "black"}}*/}
          {/*          onClick={() => this.handleInterrupt()}>interrupt</Button>}*/}
          {(this.state.status === LiveStreamConductorStatus.stream_started_automatically || this.state.status === LiveStreamConductorStatus.stream_started_manually) &&
            <Button type={"primary"} style={{backgroundColor: "black", borderColor: "black", marginRight: "20px"}}
                    onClick={() => this.handlePause()}>توقف پخش زنده</Button>}
          {(this.state.status === LiveStreamConductorStatus.stream_paused_manually) &&
            <Button type={"primary"} style={{backgroundColor: "green", borderColor: "green", marginRight: "20px"}}
                    onClick={() => this.handleResume()}>ادامه پخش زنده</Button>}
        </Row>
      </Form>
    );
  }
}

export default withFormWrapper(
  Form.create({name: "conductor-form"})(ConductorForm)
);
